module.exports = __webpack_public_path__ + "static/img/pic6.f9dab23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_image/home/pic6.png
// module id = c16k
// module chunks = 20